import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const Modal = ({ title, subtitle, subtitle: { firstLine, secondLine }, onClose, children }) => (
  <div className="modal__container">
    <div className="modal">
      <div className="modal__container__close">
        <button type="button" onClick={onClose} className="modal__container__close__button">
          <i className="far fa-times" />
        </button>
      </div>
      {title && <div className="modal__title">{title}</div>}
      {subtitle && (
        <>
          <div className="modal__subtitle">
            {firstLine}
            <span>{secondLine}</span>
          </div>
        </>
      )}
      <div className="modal__content">{children}</div>
    </div>
  </div>
);

Modal.defaultProps = {
  title: '',
  subtitle: '',
};

Modal.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClose: PropTypes.func.isRequired,
};

export default Modal;
